import * as MuiIcons from '@mui/icons-material';
import { EcoLeafIcon } from '@/components/atoms/customIcons/ecoLeaf';
import { MapSearchIcon } from '@/components/atoms/customIcons/mapSearchIcon';
import { NatureIcon } from '@/components/atoms/customIcons/nature';
import { BarChart4Icon } from '@/components/atoms/customIcons/barChart4';
import { SparklesIcon } from '@/components/atoms/customIcons/sparklesIcon';

const customIcons = {
  EcoLeafIcon,
  MapSearchIcon,
  Trees: NatureIcon,
  BarChart4Icon,
  SparklesIcon,
};

interface DynamicIconProps {
  name: string;
  size?: number;
  color?: string;
}

export const DynamicIcon = ({ name, size = 24, color = 'inherit' }: DynamicIconProps) => {
  // 1️⃣ Tenta encontrar nos ícones do Material UI
  const MuiIcon = (MuiIcons as Record<string, React.ElementType>)[name];

  // 2️⃣ Se não encontrar, tenta nos ícones customizados
  const CustomIcon = (customIcons as Record<string, React.ElementType>)[name];

  const IconComponent = MuiIcon || CustomIcon;

  if (!IconComponent) {
    console.warn(`Ícone "${name}" não encontrado.`);
    return null;
  }

  return <IconComponent sx={{ fontSize: size, color }} />;
};
